import { PromoPageContent } from 'components/common/PromoPageContent';
import { usePromotion } from 'hooks/pages/usePromotion';
import { useRouter } from 'next/router';

export const Promotion = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: promotion } = usePromotion(slug as string);

  return <PromoPageContent {...promotion} />;
};
